// eslint-disable-next-line no-unused-vars
import { LoaderOptions } from '@googlemaps/js-api-loader';

const { googleMapApiKey: apiKey } = window.drupalSettings.ctGeolocation || '';

const libraries = ['places'];

/** @type { LoaderOptions } */

const googleMapsWrapperConfig = {
  apiKey,
  libraries,
};

export default googleMapsWrapperConfig;
